import {Box} from '@primer/react'
import {CommentDivider, CommentLoading} from '@github-ui/commenting'

import {VALUES} from '../constants'

export const IssueTimelineLoading = ({rowCount = VALUES.rowLoadingSkeletonCount}: {rowCount?: number}) => {
  return (
    <Box>
      <CommentDivider />
      {[...Array(rowCount)].map((_, index) => (
        <Box key={index}>
          <CommentLoading />
          <CommentDivider />
        </Box>
      ))}
    </Box>
  )
}

try{ IssueTimelineLoading.displayName ||= 'IssueTimelineLoading' } catch {}